import { WidgetWithConfigState } from 'widgets/store/configuration/WidgetWithConfigState';
import {
    initialMyPortfolioCapsulesConfigState,
    MyPortfolioCapsulesWidgetConfigState,
} from './config/MyPortfolioCapsulesWidgetConfigState';

export type MyPortfolioCapsulesWidgetState =
    WidgetWithConfigState<MyPortfolioCapsulesWidgetConfigState>;

export interface MyPortfolioCapsulesWidgetsState {
    [widgetKey: string]: MyPortfolioCapsulesWidgetState;
}

export const initialMyPortfolioCapsulesWidgetState: MyPortfolioCapsulesWidgetState =
    {
        config: initialMyPortfolioCapsulesConfigState,
    };

export const initialMyPortfolioCapsulesWidgetsState: MyPortfolioCapsulesWidgetsState =
    {};
